module.exports = __webpack_public_path__ + "static/media/MfFlag.c4ae148b.svg";